import React, { useCallback, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { App } from '@gin-betting/core';

import { ODD_FORMAT_BODY_ATTR } from 'app-constants';
import globalMsg from 'messages';
import { checkValueInObj } from 'utils';
import { changeOddFormat } from '../../actions';
import { selectOddFormat } from '../../selectors';

interface Output {
    currOddFormat: App.OddFormat;
    title: string;
    filteredOddFormats: App.OddFormat[];
    onMouseDown: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

/* TODO delete App.OddFormat.Fractional in future */
const filteredOddFormats = Object.values(App.OddFormat).filter(
    format => format !== App.OddFormat.Fractional
);

const useOddFormatSelect = (): Output => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const currOddFormat = useSelector(selectOddFormat);

    const onMouseDown: Output['onMouseDown'] = useCallback(
        e => {
            const { format: oddFormat } = e.currentTarget.dataset;

            if (!checkValueInObj(App.OddFormat, oddFormat)) return;

            dispatch(
                changeOddFormat({
                    oddFormat,
                })
            );
        },
        [dispatch]
    );

    const title = formatMessage(globalMsg.oddsFormat);

    useEffect(() => {
        document.body.setAttribute(ODD_FORMAT_BODY_ATTR, currOddFormat);
    }, [currOddFormat]);

    return {
        currOddFormat,
        title,
        filteredOddFormats,
        onMouseDown,
    };
};

export default useOddFormatSelect;
